<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div class="modal">
        <header class="modal-header">
          <slot name="header">Accorder l'accès aux interlocuteurs</slot>
        </header>

        <section class="modal-body">
          <ul>
            <li
              v-for="interlocuteur in interlocuteurs"
              :key="interlocuteur._id"
            >
              <label>
                <input
                  type="checkbox"
                  :value="interlocuteur.email"
                  v-model="selectedInterlocuteur"
                />
                {{ interlocuteur.nom }} {{ interlocuteur.prenom }}
              </label>
            </li>
          </ul>
        </section>

        <footer class="modal-footer">
          <button class="btn-green" @click="validerAccess">Valider</button>
          <button class="btn-red" @click="closeAccess">Annuler</button>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ConfirmationModel",
  data() {
    return {
      selectedInterlocuteur: [],
    };
  },
  props: {
    interlocuteurs: Array,
    interlocuteurPartage : Array,
    idAccess: String,
  },
  methods: {
    validerAccess() {
      this.$emit("validerAccess", this.selectedInterlocuteur, this.idAccess);
    },
    closeAccess() {
      this.$emit("closeAccess");
    },
  },

  mounted() {
    // ننسخو قيم interlocuteurPartage ل selectedInterlocuteur باش يتشطبو الشيك بوكس أوتوماتيكياً
    this.selectedInterlocuteur = [...this.interlocuteurPartage];
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal {
  background: #ffffff;
  min-width: 400px;
  max-width: 600px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  animation: fadeIn 0.3s ease-in-out;
}

.modal-header {
  background-color: #f4f4f4;
  color: #333;
  font-size: 20px;
  font-weight: bold;
  padding: 20px;
  text-align: center;
  border-bottom: 1px solid #ddd;
}

.modal-body {
  padding: 20px;
  font-size: 16px;
  color: #555;
  max-height: 300px;
  overflow-y: auto;
}

.modal-body ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.modal-body li {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.modal-body label {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #333;
  cursor: pointer;
}

.modal-body input[type="checkbox"] {
  margin-right: 10px;
  transform: scale(1.2);
  cursor: pointer;
}

.modal-footer {
  padding: 20px;
  display: flex;
  justify-content: center;
  gap: 10px;
  border-top: 1px solid #ddd;
}

.btn-green,
.btn-red {
  width: 120px;
  padding: 12px;
  font-size: 16px;
  font-weight: 500;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-green {
  background-color: #4caf50;
  color: #fff;
}

.btn-green:hover {
  background-color: #45a049;
}

.btn-red {
  background-color: #f44336;
  color: #fff;
}

.btn-red:hover {
  background-color: #d32f2f;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
